export const getUserStore = state => state.locationStore.userStore;